module.exports = __webpack_public_path__ + "img/tosee.ab81f3ac.png";